import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { STextField } from './styled';
import { Box as MuiBox } from '@mui/material';
import { FormControl, JamIcon } from 'components/ui';
import FormPhoneInput from 'components/ui/FormPhoneInput';

export default function EmergencyContactPerson() {
  const { t } = useTranslation();

  return (
    <Accordion
      title={t('Emergency contact person')}
      startAdornment={<JamIcon icon="viber-circle" />}
    >
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('First name')}>
          <STextField
            name="emergencyContactPerson.firstName"
            placeholder={t('First name')}
          />
        </FormControl>
        <FormControl label={t('Last name')}>
          <STextField
            name="emergencyContactPerson.lastName"
            placeholder={t('Last name')}
          />
        </FormControl>
      </MuiBox>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('Email')}>
          <STextField
            name="emergencyContactPerson.email"
            placeholder={t('Email')}
          />
        </FormControl>
        <FormPhoneInput
          name="emergencyContactPerson.phoneNumber"
          data-id="phone"
        />
      </MuiBox>
    </Accordion>
  );
}
